// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"255":"test","586":"reader"}[chunkId] + "." + {"255":"adf1596e","586":"b3aaca2d"}[chunkId] + ".css";
};